import { render, staticRenderFns } from "./cardEducationEdit.vue?vue&type=template&id=acc046de&scoped=true"
import script from "./cardEducationEdit.vue?vue&type=script&lang=js"
export * from "./cardEducationEdit.vue?vue&type=script&lang=js"
import style0 from "./cardEducationEdit.vue?vue&type=style&index=0&id=acc046de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc046de",
  null
  
)

export default component.exports